import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

export default function AuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setToken } = useAuth();
  const exchanged = useRef(false);

  useEffect(() => {
    if (exchanged.current) return;
    exchanged.current = true;

    const code = searchParams.get('code');
    if (!code) {
      navigate('/login?error=Google+sign-in+failed', { replace: true });
      return;
    }

    axios
      .post<{ token: string }>('/api/auth/exchange', { code })
      .then((res) => {
        setToken(res.data.token);
        navigate('/', { replace: true });
      })
      .catch(() => {
        navigate('/login?error=Google+sign-in+failed', { replace: true });
      });
  }, [searchParams, setToken, navigate]);

  return (
    <div className="min-h-[40vh] flex items-center justify-center">
      <p className="text-gray-600">Signing you in...</p>
    </div>
  );
}
